"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isEmptyChildren;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var isPlaceholder = function isPlaceholder(child) {
  return child && child.props && child.props.text === 'child placeholder';
};

var isOverride = function isOverride(child) {
  return child && child.props && typeof child.props.slot === 'string' && child.props.slot.length > 0;
};

function isEmptyChildren(children) {
  var childrenArray = _react["default"].Children.toArray(children);

  return !childrenArray.some(function (child) {
    return child && !isPlaceholder(child) && !isOverride(child);
  });
}